import * as fabric from 'fabric/fabric-impl';
import { customFabricFields } from 'src/app/common/interfaces/sync-service-interface';
import { FrameItem } from 'src/app/models/session';
import { v4 as uuidv4 } from 'uuid';
import { YCanvasItemObject, YObject } from './y-session';

/**
 * Converts a FrameItem to a YCanvasItemObject, item.fresh is set to false
 */
export function convertFrameItemToYCanvasItem(
  frameItem: FrameItem,
  userId?: string,
): YCanvasItemObject {
  const item = frameItem as YCanvasItemObject;
  item.userId = userId;
  item.uid = uuidv4();
  item.vuid = uuidv4();
  item.fresh = false;
  return item;
}

/**
 * Converts a fabric.Object to a YObject, item.fresh is set to false
 */
export function convertFabricObjectToYObject(
  fabricObject: fabric.Object,
  userId?: string,
): YObject {
  const yObj = fabricObject as YObject;
  yObj.userId = userId;
  yObj.uid = uuidv4();
  yObj.fresh = false;
  yObj.vuid = uuidv4();
  return yObj.toObject(customFabricFields);
}
